import VueBaseController from '../vue_base'

export class IndexController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/clients/autopilot/index.vue') }

  static values = {
    clientId: String,
    autopilotStarted: Boolean,
    businessName: String,
    businessUrl: String,
    websiteId: String
  }

  connect() {
    super.connect({
      clientId: this.clientIdValue,
      autopilotStarted: this.autopilotStartedValue,
      businessName: this.businessNameValue,
      businessUrl: this.businessUrlValue,
      websiteId: this.websiteIdValue
    })
  }
}
